import React, { createContext, useState, useEffect } from 'react';

export const ActiveTeamContext = createContext();

export const ActiveTeamProvider = ({ children }) => {
    const [activeTeamId, setActiveTeamIdState] = useState(
        localStorage.getItem('activeTeamId') || null
    );

    const setActiveTeamId = React.useCallback((id) => {
        const strId = id ? id.toString() : null;
        setActiveTeamIdState(strId);
        if (strId) {
            localStorage.setItem('activeTeamId', strId);
        } else {
            localStorage.removeItem('activeTeamId');
        }
    }, []);

    const contextValue = React.useMemo(() => ({
        activeTeamId,
        setActiveTeamId
    }), [activeTeamId, setActiveTeamId]);

    return (
        <ActiveTeamContext.Provider value={contextValue}>
            {children}
        </ActiveTeamContext.Provider>
    );
};
